<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getFaqCategoryTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionFaqCategory && permissionFaqCategory.permission_id === permission.readWrite"
          @click.native="createFaqCategoryData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable" :key="data.category_id">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.category_name}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showFaqCategoryData(data.category_id)">
                <icon-pencil/>
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../components/Icon/icon-pencil";
  import CircleButton from "../../components/Button/CircleButton";
  import InputSearch from "../../components/Input/InputSearch";
  import Paginate from "../../components/Layout/Paginate";
  import {permissionFaqCategory, role} from "../../util/Permission";
  import Loading from 'vue-loading-overlay';
  import {mapState} from "vuex";
  import Swal from "sweetalert";
  export default {
    name: "FaqCategoryCategoryTable",
    components: {Paginate, InputSearch, CircleButton, IconPencil, Loading},
    data() {
      return {
        title: "FaqCategory",
        isLoading: false,
        headers: [
          { id: 1, text: "No." },
          { id: 2, text: "Category name" },
          { id: 3, text: "Update date" },
          { id: 4, text: "Edit" },
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        search : '',
      };
    },
    created() {
      this.permission = role;
      this.getFaqCategoryTable(1);
    },
    computed: {
      permissionFaqCategory,
    },
    methods:{
      getFaqCategoryTable(page){
        this.isLoading = true;
        this.$store.dispatch("FaqCategory/getFaqCategory",{
          page,
          search : this.search
        }).then(res=>{
          if(res.response_code == 200){
            this.dataTable = res.result.data;
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get FaqCategory data','error');
          this.isLoading = false;
        })
      },
      goToFaqCategoryEdit(){
        this.$router.push("/faq-category/edit");
      },
      showFaqCategoryData(id){
        this.isLoading = true;
        this.$store.dispatch("FaqCategory/showFaqCategory",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("FaqCategory/setFormFaqCategory",res.result).then(()=>{
              this.goToFaqCategoryEdit();
            })
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get FaqCategory data','error');
          this.isLoading = false;
        });
      },
      createFaqCategoryData(){
        this.$store.dispatch("FaqCategory/clearFormData").then(()=>{
          this.goToFaqCategoryEdit();
        });
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getFaqCategoryTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      searchInput(val){
        this.search = val;
      },
    }
  }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
